import React from 'react';
import { Instagram, Mail } from 'lucide-react';

export default function Footer() {
  return (
    <section className="bg-[#aeb4bf] dark:bg-secondary-900/90">
      <div className="container-padded mx-auto max-w-6xl py-7">
        <div className="flex flex-col items-center gap-1">
          <img src="/home-footer-logo.svg" alt="De CoBank logo" className="h-44 w-44 opacity-85 dark:brightness-0 dark:invert" />
          <a
            href="mailto:support@decobank.nl"
            className="home-rounded -mt-3 inline-flex items-center gap-2 text-lg text-[#4f5968] underline underline-offset-4 transition-colors hover:text-[#3e4652] sm:text-xl dark:text-secondary-200 dark:hover:text-secondary-100"
          >
            <Mail size={20} />
            support@decobank.nl
          </a>
          <a
            href="https://instagram.com/de_cobank"
            target="_blank"
            rel="noreferrer"
            className="home-rounded inline-flex items-center gap-2 text-lg text-[#4f5968] transition-colors hover:text-[#3e4652] sm:text-xl dark:text-secondary-200 dark:hover:text-secondary-100"
          >
            <Instagram size={20} />
            de_cobank
          </a>
        </div>
      </div>
    </section>
  );
}
